import { AdvancedFilterCondition } from "./AdvancedFilterCondition";

export class AdvancedQueryRequest {
  filters: AdvancedFilterCondition[] = [];
  sorts: any[] = [];
  page: number = -1;
  pageSize: number = 0;
  includeTotalCount: boolean = true;
  includeTotalComment: boolean = false;
}
